import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email) return;
    setSubmitting(true);
    try {
      const formData = new URLSearchParams();
      formData.append('email', email);
      await fetch('https://readdy.ai/api/form/d6301lqbdoed7v0v8ifg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });
      setSubmitted(true);
      setEmail('');
    } catch (err) {
      console.error('Newsletter subscription failed:', err);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <footer className="relative overflow-hidden">
      <div className="absolute top-0 left-0 right-0 z-10">
        <svg viewBox="0 0 1440 80" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto">
          <path d="M0 0L0 40C360 80 720 60 1080 40C1260 30 1380 20 1440 30L1440 0L0 0Z" fill="white"/>
        </svg>
      </div>

      <div className="bg-[#f5f0eb] pt-20 md:pt-24 pb-8 px-4 sm:px-6 lg:px-16">
        <div className="absolute top-20 right-20 w-64 h-64 bg-[#F49729]/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 left-20 w-48 h-48 bg-[#F49729]/5 rounded-full blur-3xl"></div>

        <div className="max-w-6xl mx-auto relative z-10">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-7 md:gap-10 mb-10 md:mb-14">
            <div className="col-span-2 md:col-span-1">
              <Link to="/">
                <img
                  src="https://static.readdy.ai/image/45f36db358624bab4161a57e418814dc/952de5dd7ee479a30999c64f6b1ab29c.png"
                  alt="GO TALENTS"
                  className="h-12 md:h-20 w-auto object-contain mb-4 md:mb-5 cursor-pointer"
                />
              </Link>
            </div>

            <div>
              <h4 className="text-xs font-semibold text-[#111111] uppercase tracking-wider mb-4 md:mb-5">
                <a href="/">Quick Links</a>
              </h4>
              <div className="space-y-3">
                <Link to="/hire-talent" className="block text-sm text-[#61616A] hover:text-[#F49729] transition-colors cursor-pointer">
                  Hire Talent
                </Link>
                <Link to="/apply-talent" className="block text-sm text-[#61616A] hover:text-[#F49729] transition-colors cursor-pointer">
                  Apply as Talent
                </Link>
              </div>
            </div>

            <div>
              <h4 className="text-xs font-semibold text-[#111111] uppercase tracking-wider mb-4 md:mb-5">
                <a href="mailto:contact@gotalentsglobal.com">Contact</a>
              </h4>
              <a
                href="mailto:contact@gotalentsglobal.com"
                className="block text-sm text-[#61616A] hover:text-[#F49729] transition-colors mb-4 cursor-pointer break-all"
              >
                contact@<wbr />gotalentsglobal.com
              </a>
              <div className="flex items-center gap-3">
                <a
                  href="https://www.linkedin.com/company/go-talentsglobal"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-white text-[#61616A] hover:text-[#F49729] hover:shadow-lg transition-all cursor-pointer"
                >
                  <i className="ri-linkedin-fill text-base"></i>
                </a>
              </div>
            </div>

            <div className="col-span-2 md:col-span-1">
              <h4 className="text-xs font-semibold text-[#111111] uppercase tracking-wider mb-3 md:mb-5">
                Newsletter
              </h4>
              <p className="text-sm text-[#61616A] mb-3 md:mb-4">
                Stay updated with the latest opportunities and insights.
              </p>
              {submitted ? (
                <div className="bg-[#F49729]/10 rounded-2xl p-4">
                  <p className="text-sm text-[#F49729] font-medium">Thank you for subscribing!</p>
                </div>
              ) : (
                <form
                  id="newsletter-form"
                  data-readdy-form=""
                  onSubmit={handleSubmit}
                  className="flex gap-2"
                >
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Your email"
                    required
                    className="flex-1 min-w-0 px-4 py-3 text-sm bg-white border-0 rounded-l-full focus:outline-none focus:ring-2 focus:ring-[#F49729]/30 transition-all"
                  />
                  <button
                    type="submit"
                    disabled={submitting}
                    className="px-4 py-3 bg-[#F49729] text-white rounded-r-full hover:bg-[#e08820] transition-colors cursor-pointer whitespace-nowrap disabled:opacity-60"
                  >
                    <i className="ri-arrow-right-line text-sm"></i>
                  </button>
                </form>
              )}
            </div>
          </div>

          <div className="pt-6 md:pt-8 border-t border-[#d9d0c5] flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-xs text-[#7F7F84]">&copy; 2026 GO TALENTS.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
